import { create } from "zustand";

const useUserStore = create((set) => ({
  userAddress: "",
  userFullName: "",
  userFirstName: "",
  userEmail: "",
  userCountry: "",
  userCountryCode: "",
  userBalance: "",
  userRole: "investor",
  userKycStatus: 0,
  userImageLink: "",
  userType: "",
  userId: "",
  userGTNCustomerId: "",
  accessToken: "",
  isConnected: false,

  setUser: ({ name: paramName, value: paramValue }) =>
    set((state) => ({ [paramName]: paramValue })),

  resetUser: () =>
    set(() => ({
      userAddress: "",
      userFullName: "",
      userFirstName: "",
      userEmail: "",
      userCountry: "",
      userCountryCode: "",
      userBalance: "",
      userRole: "investor",
      userKycStatus: 0,
      userImageLink: "",
      userType: "",
      userId: "",
      userGTNCustomerId: "",
      accessToken: "",
      isConnected: false,
    })),
}));

export default useUserStore;
